import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'allKeys',
    standalone: false
})

export class AllKeysPipe implements PipeTransform {
  transform(value: any): Array<string> {
    return Object.keys(value);
  }
}
